import mutations from './mutations'
// import actions from './actions'

const state = {
    tabtype: 1,//个性化作业详情tab切换
};


export default {
    state,
    mutations
}
